import './App.css';
import StepForm from './components/StepForm'

function App() {
    return ( 
        <div>
            <StepForm />
        </div>
    );
    }

export default App;